<template>
  <v-list-item-content
    :class="[{'px-2':panelView},hover&&panelView?'white clickable':'','my-2', width]"
    @mouseover="hover=true"
    @mouseleave="hover=false"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <h4 class="text--grey text--darken-1">{{item.brand_name}}</h4>
    <v-row :class="width">
      <v-col cols="12" class="pb-0 pt-1">
        <v-list-item-title class="text-body-1 mb-2 text-capitalize text-wrap">
          {{item.generic_name}}
        </v-list-item-title>
      </v-col>
      <v-col cols="12" class="pb-0 pt-0 d-flex">
        <v-col cols="5" align-self="center" class="pt-0 pb-0">
          <v-list-item-subtitle>
            - {{item.strength}}
          </v-list-item-subtitle>
        </v-col>
        <v-col cols="5" align-self="center" class="pt-0 pb-0">
          <v-list-item-subtitle>
            - {{item.dosage}}
          </v-list-item-subtitle>
        </v-col>
        <v-col cols="2" class="pb-0 pt-0">
          <v-btn
            @click.stop="updateFavorites"
            dense
            icon
          >
            <v-icon
              large
              @click.stop="updateFavorites"
              :color="isStarred ?'yellow darken-2':'grey'"
            >
              mdi-star
            </v-icon>
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
  </v-list-item-content>
</template>

<script>
  export default {
    name: 'MedicineItem',

    props: {
      item: { type: Object },
      panelView: { type: Boolean, default: false },
      width: { type: String, default: 'width415' }
    },

    data: () => ({
      starred: null,
      hover: false
    }),

    computed: {
      isStarred() {
        if (this.favoriteMedicines && this.favoriteMedicines.length > 0) {
          var found = this.favoriteMedicines.findIndex(item => item.id == this.item.id)
          return found >= 0 ? true : false
        }
        else {
          return false
        }
      },
      favoriteMedicines() {
        return this.$store.getters['medicine/fave_medicines']
      },
      mostUsedMedicines() {
        var medicines = this.$store.getters['medicine/used_medicines']
        var sortedMedicines = medicines.sort((a,b) => a.uses - b.uses)
        return sortedMedicines
      }
    },

    mounted() {
      this.starred = this.isStarred
    },

    methods: {
      updateFavorites() {
        this.$store.dispatch('medicine/updateFavorites', this.item)
        this.starred = !this.starred
      }
    }
  }
</script>

<style lang="scss" scoped>
.med {
  font-size: 13px !important;

  .head-text {
    font-size: 15px;
  }
}

.width415 {
  max-width: 415px;
}

.widthInherit {
  max-width: inherit;
}
</style>